import React, { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import {
  IconButton,
  Box,
  Grid,
  FormControlLabel,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  FormLabel,
} from "@material-ui/core";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Autocomplete, Tab, Tabs, Tooltip } from "@mui/material";

import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import { borderLeft, styled, useMediaQuery, useTheme } from "@mui/system";

import { makeStyles } from "@material-ui/core/styles";

import "./newAssessmentForm.scss";
import Question from "./questions/Question";
import History from "./history/History";
import Findings from "./findings/Findings";
import FileUpload from "./attachment/Attachment";
import CaseStudy from "./case_study/CaseStudy";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../redux/store";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { convertToIso, db } from "../../../../database";
import { updateNewAssessmentVariable } from "../../../../redux/slices/globalVariableSlice";
import { toast } from "react-toastify";
import ProjectDetailsBar from "../project-details-bar/ProjectDetailsBar";
import axiosInstance from "../../../../httpInterceptor";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import Modal from "react-modal";
import {
  AssessmentData,
  ProjectDataType,
  Qnadetails,
} from "../../../../models/interfaces/interfaces";
import Loading from "../../../layout/loader/Loading";
import { MdEmail } from "react-icons/md";
import axios from "axios";
import { transform } from "typescript";

import { SxProps, Theme } from "@mui/system";

// import SaveAssessmentDetails from "../../leadership-report/SaveAssessmnetDetails";
// import PdfExport from "../../leadership-report/pdfExport";
import SendNotification from "./email/email";
// import ScaleLoader from "react-spinners/ScaleLoader";
// import RingLoader from "react-spinners/RingLoader";
const NewAssessmentForm: React.FC = () => {
  const { proj_id, set_name } = useParams<{
    proj_id: string;
    set_name: string;
  }>();

  // Debug: Log the parameters immediately
  console.log("useParams Debug - proj_id:", proj_id, "set_name:", set_name);
  console.log("Current URL path:", window.location.pathname);

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  // Detect if user entered from Project Readiness Dashboard
  const fromProjectReadiness = location.state?.fromProjectReadiness === true;
  const readinessData = location.state?.readinessData || null;

  // State for editable Project Readiness form fields
  const [readinessFormData, setReadinessFormData] = useState({
    assessorName: readinessData?.assessorName || "",
    projectDescription: readinessData?.projectDescription || "",
  });
  const [isReadinessFormModified, setIsReadinessFormModified] = useState(false);

  let newAssessmentVar = JSON.parse(
    sessionStorage.getItem("newAssessment") || ""
  );
  // state for changing the tabs between question,history and findings
  const [activeTab, setActiveTab] = useState("questions");

  // Handle direct navigation to specific tab (e.g., from dashboard case study count)
  useEffect(() => {
    if (location.state && location.state.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);
  const [isReAssessClicked, setIsReAssessClicked] = useState(false);
  const [reviewer, setReviewerData] = useState<any>(null);
  const [reviewerNames, setReviewerNames] = useState<any>(null);
  const [isAssessForThisProjId, setIsAssessForThisProjId] =
    useState<boolean>(true);
  //state to handle accordion like to show or hide the project form
  const [isopen, setIsOpen] = useState(false);

  // Modal and loader state for LLM
  const [showLlmModal, setShowLlmModal] = useState(false);
  const [llmModalContent, setLlmModalContent] = useState<{ message: string; messageId: string } | null>(null);
  const [projectHealthData, setProjectHealthData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isEnabled1, setIsEnabled1] = useState(false);
  const [progess, setProgess] = useState(false);
  const [isCharLimitExceeded, setIsCharLimitExceeded] = useState(false);

  const [setname, setName] = useState("");
  const [emails, setEmails] = useState<string[]>([]);
  const [showEmailField, setShowEmailField] = useState(false);
  const [isSubmitButton, setIsSubmitButton] = useState(false);
  const [color, setColor] = useState<string[]>([]);
  const [findings, setFindings] = useState<any[]>([]);
  const [formattedDate, setFormattedDate] = useState("");
  // Track if a draft exists for the current project and set
  const [hasDraft, setHasDraft] = useState(false);
  
  // PDF-related state variables
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [viewPdfEnabled, setViewPdfEnabled] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfPolling, setPdfPolling] = useState(false); // Track if we're polling for PDF updates
  // Track if assessment was just submitted successfully (even if LLM fails)
  const [assessmentJustSubmitted, setAssessmentJustSubmitted] = useState(false);
  const [generateReportLoading, setGenerateReportLoading] = useState(false);

  // Watch for draft changes in localStorage
  useEffect(() => {
    const draftKey = `responses_${proj_id}_${set_name}`;
    const draftMetaKey = `draft_meta_${proj_id}_${set_name}`;
    const checkDraft = () => {
      const draft = JSON.parse(localStorage.getItem(draftKey) || "[]");
      setHasDraft(draft.length > 0);
      
      // Load draft meta data (projectstatus and reasonforchange)
      const draftMeta = JSON.parse(localStorage.getItem(draftMetaKey) || "{}");
      if (draftMeta.projectstatus || draftMeta.reasonforchange) {
        setAssessmentData((prevState: any) => ({
          ...prevState,
          assessmentdetails: prevState.assessmentdetails.map((detail: any) => ({
            ...detail,
            projectstatus: draftMeta.projectstatus || detail.projectstatus,
            reasonforchange: draftMeta.reasonforchange || detail.reasonforchange,
          })),
        }));
      }
    };
    checkDraft();
    window.addEventListener("storage", checkDraft);
    return () => window.removeEventListener("storage", checkDraft);
  }, [proj_id, set_name, isReAssessClicked, activeTab]);

  useEffect(() => {
    newAssessmentVar = JSON.parse(
      sessionStorage.getItem("newAssessment") || ""
    );
  }, [isReAssessClicked]);

  // Fetch PDF URL on component mount
  useEffect(() => {
    const fetchPdfUrl = async () => {
      if (proj_id && set_name) {
        try {
          const authToken = sessionStorage.getItem("PBT_ID_TOKEN");
          const created_by = `${sessionStorage.getItem("PBT_FIRSTNAME") || ""} ${sessionStorage.getItem("PBT_LASTNAME") || ""}`.trim();
          const response = await axios.get(
            `${process.env.REACT_APP_LLM_SERVICE_BASE_URL}/report/${proj_id}/${set_name}`,
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
              }
            }
          );
          
          const latestUrl = response.data?.latest_url;
          const createdBy = response.data?.created_by;
          
          // Check if we have a valid PDF URL (not empty/blank)
          if (latestUrl && latestUrl.trim() !== "" && latestUrl !== "undefined" && latestUrl !== "null") {
            setPdfUrl(latestUrl);  // Only set the URL string
            setViewPdfEnabled(true);
            setPdfPolling(false); // Stop polling if we have a valid URL
          } else if (response.data?.latest_url !== undefined) {
            // Report exists but URL is blank - keep button disabled and start polling
            setPdfUrl(null);
            setViewPdfEnabled(false);
            setPdfPolling(true); // Start polling for updates (even on page revisit)
            console.log("PDF URL is blank, starting polling for updates...");
          } else {
            // No report found at all
            setPdfUrl(null);
            setViewPdfEnabled(false);
            setPdfPolling(false);
          }
        } catch (error) {
          console.log("No existing PDF found:", error);
          setPdfUrl(null);
          setViewPdfEnabled(false);
          setPdfPolling(false);
        }
      }
    };

    fetchPdfUrl();
  }, [proj_id, set_name]);

  // Polling mechanism to check for PDF URL updates
  useEffect(() => {
    let pollingInterval: NodeJS.Timeout | null = null;

    const pollForPdfUrl = async () => {
      if (!pdfPolling || !proj_id || !set_name) return;

      console.log("Polling for PDF URL updates...");
      
      try {
        const authToken = sessionStorage.getItem("PBT_ID_TOKEN");
        const created_by = `${sessionStorage.getItem("PBT_FIRSTNAME") || ""} ${sessionStorage.getItem("PBT_LASTNAME") || ""}`.trim();
        const response = await axios.get(
          `${process.env.REACT_APP_LLM_SERVICE_BASE_URL}/report/${proj_id}/${set_name}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${authToken}`
            }
          }
        );

        const latestUrl = response.data?.latest_url;
        const createdBy = response.data?.created_by;
        
        console.log("Polling result - URL:", latestUrl, "Created by:", createdBy);
        
        // Check if PDF URL has been generated (transition from blank to valid)
        if (latestUrl && latestUrl.trim() !== "" && latestUrl !== "undefined" && latestUrl !== "null") {
          console.log("Valid PDF URL found, enabling button and stopping polling");
          setPdfUrl(latestUrl);  // Only set the URL string
          setViewPdfEnabled(true);
          setPdfPolling(false); // Stop polling once we get the URL
          // Close any open LLM modal and enable Send Notification tab
          setShowLlmModal(false);
          toast.success("New PDF is generated! You can now view it.");
        } else if (response.data?.latest_url === undefined) {
          // No report found, stop polling
          console.log("No report found, stopping polling");
          setPdfPolling(false);
        } else {
          console.log("PDF URL still blank, continuing polling...");
        }
        // If URL is still blank, continue polling (don't update state)
      } catch (error) {
        console.log("Error polling for PDF:", error);
        // Continue polling even on error - might be temporary network issue
      }
    };

    if (pdfPolling) {
      console.log("Starting PDF polling interval (10 seconds)");
      // Poll immediately, then every 10 seconds
      pollForPdfUrl();
      pollingInterval = setInterval(pollForPdfUrl, 10000);
    }

    // Cleanup interval on unmount or when polling stops
    return () => {
      if (pollingInterval) {
        console.log("Stopping PDF polling interval");
        clearInterval(pollingInterval);
      }
    };
  }, [pdfPolling, proj_id, set_name]);

  // Add missing state variables - Initialize with URL params
  const [projectData, setProjectData] = useState({
    proj_id: proj_id || "",
    proj_name: proj_id || "", // Fallback to proj_id if name is not loaded yet
    type: "",
    pmid: "",
    pmname: "",
    du: "",
    pu: "",
    account: "",
    billing_project_id: "",
    proj_start_date: "",
    proj_end_date: "",
    proj_desc: "",
    reviewer: "",
    status: "",
    set_name: set_name || "",
  });

  const [assessmentData, setAssessmentData] = useState<any>({
    projectid: proj_id || "",
    set_name: set_name || "",
    emailIds: JSON.parse(localStorage.getItem("emailIds") || "[]"),
    assessmentdetails: [
      {
        assessmentdate: `${new Date().toISOString().split("T")[0]}`,
        projectstatus: "",
        reasonforchange: "",
        qnadetails: [] as any[],
        created_by: `${sessionStorage.getItem("PBT_FIRSTNAME") || ""} ${sessionStorage.getItem("PBT_LASTNAME") || ""}`,
        modified_by: "",
      },
    ],
  });

  const [charCount, setCharCount] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [categoryScores, setCategoryScores] = useState<{ [key: string]: number }>({});
  const [overallScore, setOverallScore] = useState<number | null>(null);

  type QnaWithQuestion = {
    questionid: string;
    category: string;
    set_name: string;
    description: string;
    type: string;
    response: string;
    remarks: string;
  };

  // Add theme and mobile breakpoint
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  // Handle score updates from Question component
  const handleScoreUpdate = (scores: { [key: string]: number }) => {
    setCategoryScores(scores);
    
    // Calculate overall average score
    const scoreValues = Object.values(scores);
    if (scoreValues.length > 0) {
      const average = scoreValues.reduce((sum, score) => sum + score, 0) / scoreValues.length;
      setOverallScore(average);
    } else {
      setOverallScore(null);
    }
  };

  // Add missing functions
  const handleTabClick = (tabName: string) => {
    setActiveTab(tabName);

    if (tabName === "questions") {
      setAssessmentData((prevState: any) => ({
        ...prevState,
        assessmentdetails: prevState.assessmentdetails.map((detail: any) => ({
          ...detail,
          projectstatus: "",
          reasonforchange: "",
          assessmentdate: `${new Date().toISOString().split("T")[0]}`,
        })),
      }));
    }
  };

  // Accept isValidDraft as third argument from Question.tsx
  const updateQnaDetails = (
    response: Qnadetails,
    len: number,
    isValidDraft: boolean
  ) => {
    // Directly set score as response value (or any logic you want)
    const scoredQna = Array.isArray(response)
      ? response
          .filter(
            (qna: any) =>
              qna &&
              typeof qna === "object" &&
              qna.questionid &&
              qna.questionid !== ""
          )
          .map((qna: any) => ({
            ...qna,
            score: qna.response, // score is set as response value
          }))
      : [];
    
    setAssessmentData((prevState: any) => {
      const updatedDetails = prevState.assessmentdetails.map((detail: any) => {
        // If discarding draft (empty array and not valid), reset projectstatus and reasonforchange
        if (scoredQna.length === 0 && !isValidDraft) {
          return {
            ...detail,
            qnadetails: scoredQna,
            projectstatus: "",
            reasonforchange: "",
          };
        }
        return {
          ...detail,
          qnadetails: scoredQna,
        };
      });
      return { ...prevState, assessmentdetails: updatedDetails };
    });
    
    // If discarding draft, also remove draft meta from localStorage
    if (scoredQna.length === 0 && !isValidDraft) {
      localStorage.removeItem(`draft_meta_${proj_id}_${set_name}`);
    }
    
    setHasDraft(!!isValidDraft);
  };

  // Show details if we have either proj_id or proj_name (more lenient for local dev)
  const showDetails =
    (projectData.proj_id !== "" && projectData.proj_id !== undefined) || 
    (projectData.proj_name !== "" && projectData.proj_name !== undefined);
  
  // Debug logging
  console.log("showDetails check:", {
    proj_id: projectData.proj_id,
    proj_name: projectData.proj_name,
    showDetails,
    overallScore,
    health: projectHealthData[0]?.assessmentdetails?.[0]?.projectstatus
  });

  const handleSaveDraft = () => {
    // Validate all mandatory questions have response and remarks
    const hasError = assessmentData.assessmentdetails[0].qnadetails.some(
      (qna: any) => qna.isRequire && (!qna.response || !qna.remarks)
    );
    if (hasError) {
      toast.error(
        "Please fill all mandatory responses and remarks before saving as draft."
      );
      setHasDraft(false);
      return;
    }
    // assessmentData already has score set for all qnadetails
    localStorage.setItem(
      `responses_${proj_id}_${set_name}`,
      JSON.stringify(assessmentData.assessmentdetails[0].qnadetails)
    );
    // Save draft meta data (projectstatus and reasonforchange)
    const draftMeta = {
      projectstatus: assessmentData.assessmentdetails[0].projectstatus || "",
      reasonforchange: assessmentData.assessmentdetails[0].reasonforchange || ""
    };
    localStorage.setItem(
      `draft_meta_${proj_id}_${set_name}`,
      JSON.stringify(draftMeta)
    );
    setHasDraft(true);
    toast.success("Draft saved successfully!");
  };
  useEffect(() => {
    const formatDate = async () => {
      let rawDate = "";  
      if (!newAssessmentVar && projectHealthData.length > 0) {
        const assessmentDate = projectHealthData[0]?.assessmentdetails?.[0]?.assessmentdate;
        if (assessmentDate && typeof assessmentDate === 'string') {
          rawDate = assessmentDate.split("T")[0];
        }
      } else if (assessmentData.assessmentdetails.length > 0) {
        const assessmentDate = assessmentData.assessmentdetails[0]?.assessmentdate;
        if (assessmentDate && typeof assessmentDate === 'string') {
          rawDate = assessmentDate.split("T")[0];
        }
      }

      const result = await convertToformat(rawDate);
      setFormattedDate(result);
    };

    formatDate();
  }, [newAssessmentVar, projectHealthData, assessmentData]);

  const convertToformat = async (date: string) => {
    if (date && typeof date === 'string' && date.trim() !== "") {
      try {
        const ddmmyyyy = date.split(" ")[0];
        const dateParts = ddmmyyyy.split("-");
        if (dateParts.length === 3) {
          const year = dateParts[0];
          const month = dateParts[1];
          const day = dateParts[2];
          return `${month}-${day}-${year}`;
        }
      } catch (error) {
        console.error("Error formatting date:", error);
        return "";
      }
    }
    return "";
  };

  const fetchUserDataForReviewer = async (query: string) => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_USER_SERVICE_BASE_URL}/getPSNumber/?search=${query}`
      );

      const result = res.data.filter((item: any) => {
        if (!query) {
          setReviewerData(null);
        }
        {
          const searchText = query.toLowerCase();
          const fullName = item.name.toLowerCase();

          return query && fullName.startsWith(searchText);
        }
      });
      setReviewerData(result);
      const names = result.map((item: any) => {
        const { name, ...rest } = item;
        return name;
      });
      setReviewerNames(names);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setCharCount(projectData.proj_desc.length);
  }, [projectData.proj_desc]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log("Input change:", e.target.value);
    const { name, value } = e.target;

    if (name === "proj_desc") {
      const charCount = value.length;

      if (charCount > 100) {
        setIsCharLimitExceeded(true);
      } else {
        setIsCharLimitExceeded(false);
        setProjectData({ ...projectData, [name]: value });
      }

      setCharCount(charCount);
    } else {
      setProjectData({ ...projectData, [name]: value });
    }

    console.log(projectData.reviewer);

    if (name === "reviewer") fetchUserDataForReviewer(value);
    if (name === "proj_desc" || name === "reviewer") {
      setIsEnabled(true);
    } else {
      setIsEnabled(false);
    }
  };

  const handleAssesmentChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    if (name === "reasonforchange") {
      setIsEnabled1(true);
    } else {
      setIsEnabled1(false);
    }
    setAssessmentData((prevState: typeof assessmentData) => ({
      ...prevState,
      assessmentdetails: prevState.assessmentdetails.map((detail: any, i: any) => ({
        ...detail,
        [name]: value,
      })),
    }));
    console.log(assessmentData);
  };

  const exsistingFunctionWithColorChange = (e: any) => {
    handleAssesmentChange(e as unknown as React.ChangeEvent<HTMLInputElement>);
    const newColor = e.target.value;

    setColor((prevColors) => [...prevColors, newColor]);

    localStorage.setItem("colors", JSON.stringify(color));
  };
  useEffect(() => {
    localStorage.setItem("colors", JSON.stringify(color));
  }, [color]);

  // Helper to fetch all projects using the paginated /projects endpoint
  const fetchAllProjects = async () => {
    const allProjects: any[] = [];
    let lastKey: string | null = null;

    while (true) {
      const params: string[] = ["limit=30"];
      if (lastKey) {
        params.push(`lastKey=${encodeURIComponent(lastKey)}`);
      }
      const query = params.length ? `?${params.join("&")}` : "";

      const res = await axiosInstance.get(
        `${process.env.REACT_APP_DASHBOARD_SERVICE_BASE_URL}/projects${query}`
      );

      // Backward compatibility: old API may return full array directly
      if (Array.isArray(res.data)) {
        return res.data;
      }

      const items = res.data && Array.isArray(res.data.items) ? res.data.items : [];
      allProjects.push(...items);

      const nextKey: string | null =
        res.data && typeof res.data.nextKey === "string" && res.data.nextKey.length > 0
          ? res.data.nextKey
          : null;

      if (!nextKey) break;
      lastKey = nextKey;
    }

    return allProjects;
  };

  useEffect(() => {
    const fetProjectData = async () => {
      const projects = await fetchAllProjects();

      const localData = projects.filter(
        (item: { projectid: string; set_name: string }) =>
          item.projectid === proj_id && item.set_name === set_name
      );

      if (localData.length > 0) {
        setName(localData[0].set_name);
      } else {
        console.log("No data found for the given project ID and set.");
      }
    };
    fetProjectData();
  }, [proj_id, set_name]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // For Project Readiness, use data from location.state instead of dashboard API
        if (fromProjectReadiness && readinessData) {
          setProjectData({
            proj_id: readinessData.assessmentId || proj_id || "",
            proj_name: readinessData.projectName || "",
            type: "",
            pmid: "",
            pmname: "",
            du: readinessData.du || "",
            pu: "",
            account: readinessData.accountName || "",
            billing_project_id: "",
            proj_start_date: "",
            proj_end_date: "",
            proj_desc: readinessData.projectDescription || "",
            reviewer: readinessData.assessorName || "",
            status: "",
            set_name: readinessData.set_name || set_name || "",
          });
          setLoading(false);
          return;
        }

        // Fetch combined project details (including Compass data) from dashboard service
        const { data } = await axiosInstance.get(
          `${process.env.REACT_APP_DASHBOARD_SERVICE_BASE_URL}/project/${proj_id}/${set_name}`
        );

        if (data) {
          const {
            projectid,
            Projectname,
            Project_Category,
            primaryPM_psno,
            PM_Name,
            duname,
            puname,
            accountname,
            billing_project_id,
            start_date,
            end_date,
            proj_desc,
            reviewer,
            status,
            set_name: apiSetName,
          } = data;

          const pmPsnoValue = Array.isArray(primaryPM_psno)
            ? primaryPM_psno.join(",")
            : primaryPM_psno || "";

          const pmNameValue = Array.isArray(PM_Name)
            ? PM_Name.join(",")
            : PM_Name || "";

          setProjectData({
            proj_id: projectid || proj_id || "",
            proj_name: Projectname || "",
            type: Project_Category || "",
            pmid: pmPsnoValue,
            pmname: pmNameValue,
            du: duname || "",
            pu: puname || "",
            account: accountname || "",
            billing_project_id: billing_project_id || "",
            proj_start_date: start_date || "",
            proj_end_date: end_date || "",
            proj_desc: proj_desc || "",
            reviewer: reviewer || "",
            status: status || "",
            set_name: apiSetName || set_name || "",
          });
        } else {
          console.log("No data found for the given project ID and set.");
          // Keep the proj_id and set_name from URL params even if API fails
          setProjectData(prevData => ({
            ...prevData,
            proj_id: proj_id || prevData.proj_id,
            set_name: set_name || prevData.set_name,
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // Ensure we still have proj_id and set_name from URL params
        setProjectData(prevData => ({
          ...prevData,
          proj_id: proj_id || prevData.proj_id,
          proj_name: proj_id || prevData.proj_name, // Fallback to proj_id for display
          set_name: set_name || prevData.set_name,
        }));
      } finally {
        setLoading(false);
      }
    };
    fetchData();

    const fetchProjectHealthData = async () => {
      try {
        const isNewAssessment = JSON.parse(
          sessionStorage.getItem("newAssessment") || "false"
        );

        // Determine which service URLs to use based on flow type
        const assessmentServiceUrl = fromProjectReadiness
          ? process.env.REACT_APP_READINESS_SERVICE_BASE_URL
          : process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL;
        
        const questionServiceUrl = fromProjectReadiness
          ? process.env.REACT_APP_READINESS_QUESTION_SERVICE_BASE_URL
          : process.env.REACT_APP_QUESTION_SERVICE_BASE_URL;

        // Use appropriate endpoint for fetching assessment data
        // proj_id from URL is the real assessmentId (mapped by dashboard)
        let data;
        if (fromProjectReadiness) {
          // Workaround: Use POST createPreprojectAssessment which has working findOne logic
          // It will return existing assessment without modifying it if we send minimal payload
          const response = await axiosInstance.post(
            `${assessmentServiceUrl}/createPreprojectAssessment`,
            {
              preprojectId: proj_id,
              setName: set_name,
              emailId: [],
              assessmentDetails: [],
              caseStudyCount: 0
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );
          data = response.data;
        } else {
          const response = await axiosInstance.get(
            `${assessmentServiceUrl}/get-projectassesment/${proj_id}/${set_name}`,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );
          data = response.data;
        }

        // Handle response structure differences between regular and readiness APIs
        let assessmentDataArray: any[];
        if (fromProjectReadiness) {
          // Readiness API returns a single object, wrap it in array for consistency
          if (data && data.assessmentId) {
            assessmentDataArray = [data];
          } else if (data && data.message) {
            // No assessment found yet - treat as new assessment
            assessmentDataArray = [];
          } else {
            assessmentDataArray = Array.isArray(data) ? data : [data];
          }
        } else {
          assessmentDataArray = Array.isArray(data) ? data : [];
        }

        // Cache email IDs from the single API call
        const emailIdsFromApi = assessmentDataArray.length > 0 && assessmentDataArray[0]?.emailId
          ? assessmentDataArray[0].emailId
          : (assessmentDataArray.length > 0 && assessmentDataArray[0]?.emailIds
              ? assessmentDataArray[0].emailIds
              : []);
        setEmails(Array.isArray(emailIdsFromApi) ? emailIdsFromApi : []);

        // Get assessment details - handle different field names
        const assessmentDetails = fromProjectReadiness
          ? assessmentDataArray[0]?.assessmentDetails
          : assessmentDataArray[0]?.assessmentdetails;

        if (isNewAssessment || assessmentDataArray.length === 0 || !assessmentDetails || assessmentDetails.length === 0) {
          // For Project Readiness flow, don't auto-switch to new assessment mode
          // unless user explicitly clicks Re-assessment button
          if (!fromProjectReadiness) {
            dispatch(updateNewAssessmentVariable(true));
          }
          setIsAssessForThisProjId(false);
          return;
        }

        const len = assessmentDetails.length;

        // ✅ Fetch all questions for this set in a single API call
        // Frontend-only fix: Get all questions and filter by set on frontend
        const questionsEndpoint = fromProjectReadiness
          ? `${questionServiceUrl}/question-readiness`
          : `${questionServiceUrl}/questions-by-set/${set_name}`;
        
        const questionsResponse = await axiosInstance.get(questionsEndpoint);

        // Filter questions by set name on frontend (case-insensitive)
        const filteredQuestions = fromProjectReadiness
          ? questionsResponse.data.filter((q: any) => {
              const upperSetName = (set_name || "").toUpperCase();
              return (q.set && q.set.toUpperCase() === upperSetName) ||
                     (q.setName && q.setName.toUpperCase() === upperSetName);
            })
          : questionsResponse.data;

        const questionsMap: Map<string, any> = new Map(
          filteredQuestions.map((q: any) => [q._id, q])
        );

        const latestDetails = assessmentDetails[len - 1];
        const qnadetails = latestDetails.qnadetails || [];

        const qnadetailsWithQuestions: QnaWithQuestion[] = qnadetails
          .map((item: { questionid: string; response: string; remarks: string; description?: string }): QnaWithQuestion | null => {
            const question = questionsMap.get(item.questionid);

            if (!question) {
              console.warn(`Question not found for ID: ${item.questionid}`);
              return null;
            }

            return {
              questionid: item.questionid,
              category: question.category || "",
              set_name: question.set || question.setName || set_name,
              // Prefer stored description from assessment snapshot; fallback to current question text
              description: item.description || question.description || "",
              type: question.type || "text",
              response: item.response || "",
              remarks: item.remarks || "",
            };
          })
          .filter((entry: QnaWithQuestion | null): entry is QnaWithQuestion => entry !== null);
        console.log("qnas", qnadetailsWithQuestions);
        
        // Handle different field naming conventions
        const assessmentdate = latestDetails.assessmentdate || latestDetails.assessmentDate;
        const projectstatus = latestDetails.projectstatus || latestDetails.projectStatus || "";
        const reasonforchange = latestDetails.reasonforchange || latestDetails.reasonForChange || "";
        const created_by = latestDetails.created_by || latestDetails.createdBy || "";
        const modified_by = latestDetails.modified_by || latestDetails.modifiedBy || "";
        const created_date = latestDetails.created_date || latestDetails.createdAt || "";
        const modified_date = latestDetails.modified_date || latestDetails.updatedAt || "";

        const latestAssessment = {
          proj_id,
          set_name: set_name,
          emailIds: emailIdsFromApi,
          assessmentdetails: [
            {
              assessmentdate,
              projectstatus,
              reasonforchange,
              created_by,
              created_date,
              modified_by,
              modified_date,
              qnadetails: qnadetailsWithQuestions,
            },
          ],
        };
        console.log("assesment", latestAssessment);
        setProjectHealthData([latestAssessment]);
      } catch (error) {
        console.error("Error fetching the data", error);
      } finally {
        setLoading(false);
      }
    };

    console.log("health", projectHealthData);
    fetchProjectHealthData();
  }, [proj_id, set_name, fromProjectReadiness, readinessData]);
  console.log(projectData);
  console.log(projectHealthData);

  useEffect(() => {
    if (showEmailField) {
      document.body.classList.add("behindContentRemover");
    } else {
      document.body.classList.remove("behindContentRemover");
    }
  }, [showEmailField]);

  const handleButtonClick = async () => {
    setShowEmailField(true);
  };
  const handleCloseModal = () => {
    setShowEmailField(false);
  };

  // Handle View PDF button click
  const handleViewPdf = async () => {
    if (!proj_id || !set_name) return;
    
    setPdfLoading(true);
    try {
      const authToken = sessionStorage.getItem("PBT_ID_TOKEN");
      const created_by = `${sessionStorage.getItem("PBT_FIRSTNAME") || ""} ${sessionStorage.getItem("PBT_LASTNAME") || ""}`.trim();
      const response = await axios.get(
        `${process.env.REACT_APP_LLM_SERVICE_BASE_URL}/report/${proj_id}/${set_name}`,
        {headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${authToken}`
            }}
      );
      
      const latestUrl = response.data?.latest_url;
      const createdBy = response.data?.created_by;
      
      // Check if we have a valid PDF URL (not empty/blank)
      if (latestUrl && latestUrl.trim() !== "" && latestUrl !== "undefined" && latestUrl !== "null") {
        // PDF URL exists and is valid, open in new tab
        // Ensure any LLM modal is closed so Send Notification tab is enabled
        setShowLlmModal(false);
        window.open(latestUrl, "_blank");
        setPdfUrl(latestUrl);  // Only set the URL string
        setViewPdfEnabled(true);
        setPdfPolling(false); // Stop polling if we successfully get URL
      } else if (response.data?.latest_url !== undefined) {
        // Report exists but URL is blank, show generating message and start polling
        // Close LLM modal in case it was left open
        setShowLlmModal(false);
        toast.info("Generating PDF, please wait.");
        setPdfPolling(true); // Start polling for updates
      } else {
        // No report found at all
        toast.info("No report found. Please submit assessment first.");
      }
    } catch (error) {
      console.log("Error fetching PDF:", error);
      // Close LLM modal on error so Send Notification becomes enabled
      setShowLlmModal(false);
      toast.info("Generating PDF, please wait.");
    } finally {
      setPdfLoading(false);
    }
  };

  // Helper function to get practice unit ID
  const getPracticeUnitId = (puValue: string | undefined): number => {
    if (!puValue) return 2; // Default to Quality Engineering (TT)
    const normalized = puValue.toUpperCase().trim();
    return normalized === 'DL' ? 1 : 2; // DL = Digital Engineering (1), TT = Quality Engineering (2)
  };

  // Helper function to check if a value is N/A
  const isNAValue = (value: string | string[]): boolean => {
    if (Array.isArray(value)) {
      return value.length === 0 || value.some(v => 
        v && typeof v === 'string' && 
        (v.toUpperCase() === "N/A" || v.toUpperCase() === "NA")
      );
    }
    return !value || (typeof value === 'string' && 
      (value.toUpperCase() === "N/A" || value.toUpperCase() === "NA"));
  };

  // Helper function to sanitize array values
  const sanitizeArray = (val: any): string[] => {
    if (!val) return [];
    if (Array.isArray(val)) return val.filter(v => !!v && v !== 'N/A' && v !== 'NA');
    if (typeof val === 'string') {
      const trimmed = val.trim();
      if (trimmed === '' || trimmed.toUpperCase() === 'N/A' || trimmed.toUpperCase() === 'NA') return [];
      return [trimmed];
    }
    return [];
  };

  // Helper function to get user from session
  const getUserFromSession = (): string => {
    return sessionStorage.getItem("PBT_EMAIL") || "";
  };

  // Function to update case study count after assessment creation
  const updateCaseStudyCountProcess = async () => {
    if (!proj_id || !set_name) {
      console.error("Project ID or Set Name is missing");
      return;
    }

    try {
      // Show message to user
      toast.info("We are counting case studies...", { autoClose: false, toastId: 'case-study-counting' });

      // Step 1: Fetch project details
      console.log("Fetching project details for case study count...");
      const projectDetailsResponse = await axiosInstance.get(
        `${process.env.REACT_APP_DASHBOARD_SERVICE_BASE_URL}/project-details/${proj_id}/${set_name}`
      );

      const raw = projectDetailsResponse.data || {};
      
      // DU to Industry mapping
      const DU_TO_INDUSTRY: Record<string, string> = {
        BB: "BANKING & FINANCIAL SERVICES",
        CSU: "BANKING & FINANCIAL SERVICES",
        DSA: "BANKING & FINANCIAL SERVICES",
        BC: "BANKING & FINANCIAL SERVICES",
        ND: "BANKING & FINANCIAL SERVICES",
        BF: "BANKING & FINANCIAL SERVICES",
        EG: "ENERGY",
        GP: "ENERGY",
        EY: "ENERGY",
        HA: "HEALTH",
        HE: "HEALTH",
        HT: "HI-TECH",
        HH: "HI-TECH",
        NN: "INSURANCE",
        DL: "INSURANCE",
        NC: "INSURANCE",
        NS: "INSURANCE",
        PN: "INSURANCE",
        LS: "LIFE SCIENCES",
        MM: "MANUFACTURING",
        MN: "MANUFACTURING",
        ME: "MEDIA & ENTERTAINMENT",
        MD: "MEDIA & ENTERTAINMENT",
        FT: "MICROSOFT",
        RR: "RETAIL & CONSUMER PACKAGED GOODS",
        RE: "RETAIL & CONSUMER PACKAGED GOODS",
        TW: "TRAVEL TRANSPORT & HOSPITALITY",
        DATA: "TRAVEL TRANSPORT & HOSPITALITY",
        UL: "UTILITIES",
        UA: "UTILITIES"
      };

      const duValue: string = (
        raw.pu || raw.u_practice_unit || raw.du || raw.delivery_unit || raw.u_delivery_unit || raw.DU || raw.PU || ''
      ).toString().trim().toUpperCase();

      // Get industry with fallback to DU mapping
      const industryCandidates: string[] = [
        raw.mapped_industry,
        raw.industry,
        raw.mappedIndustry,
        raw.MAPPED_INDUSTRY,
        raw.MappedIndustry,
      ].filter(v => typeof v === 'string' && v.trim() !== '') as string[];

      let mapped_industry: string = industryCandidates.length > 0 ? industryCandidates[0].toString().trim() : '';
      
      if (!mapped_industry || /^N\/?A$/i.test(mapped_industry)) {
        mapped_industry = DU_TO_INDUSTRY[duValue] || 'N/A';
      }

      // Extract the 4 required details
      const capability = sanitizeArray(raw.capability);
      const capability_area = sanitizeArray(raw.capability_area);
      const account = raw.account || raw.account_name || '';

      console.log("Extracted project details for filter:", {
        capability,
        capability_area,
        account,
        mapped_industry
      });

      // Step 2: Call filter API with the 4 details
      const practiceUnitId = getPracticeUnitId(projectData.pu);
      const filterPayload = {
        capabilityarea: isNAValue(capability_area) ? [] : capability_area,
        capabilities: isNAValue(capability) ? [] : capability,
        industry: isNAValue(mapped_industry) ? [] : [mapped_industry],
        account: isNAValue(account) ? [] : [account],
        casestudyfilename: [],
        endmonth: null,
        endyear: null,
        geography: [],
        startmonth: null,
        startyear: null,
        teamsize: "",
        teamsizeoperator: "",
        username: getUserFromSession(),
        practice_unit_id: practiceUnitId
      };

      console.log("Calling filter API with payload:", filterPayload);
      
      const filtersResponse = await axiosInstance.post(
        `${process.env.REACT_APP_CASE_STUDY_SERVICE_BASE_URL}/casestudy/filters`,
        filterPayload,
        {
          headers: {
            "X-API-KEY": "PBTteamkey",
            "Content-Type": "application/json"
          }
        }
      );

      console.log("Filter API response:", filtersResponse.data);

      // Step 3: Process the response to extract case_study_file_link
      const processApiResponse = (data: any[]): any[] => {
        if (!Array.isArray(data)) return [];
        return data
          .map(item => {
            const key = Object.keys(item)[0];
            if (!key) return null;
            const caseStudyData = item[key];
            return {
              ...caseStudyData,
              case_study_key: key
            };
          })
          .filter(Boolean);
      };

      const processedData = processApiResponse(filtersResponse.data);
      const fileLinks = processedData
        .filter(cs => cs.case_study_file_link)
        .map(cs => cs.case_study_file_link);

      console.log("Extracted file links:", fileLinks);

      // Step 4: Call PATCH API to update case study count (always, regardless of case studies)
      await axiosInstance.patch(
        `${process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL}/update-casestudy-count/${proj_id}/${set_name}`,
        { case_study_file_links: fileLinks },
        {
          headers: {
            "X-API-KEY": "PBTteamkey",
            "Content-Type": "application/json"
          }
        }
      );

      console.log(`Case study count updated successfully (count: ${fileLinks.length})`);
      
      // Dismiss the counting message and show success
      toast.dismiss('case-study-counting');
      toast.success("Case study count is successfully updated");

    } catch (error: any) {
      console.error("Error updating case study count:", error);
      toast.dismiss('case-study-counting');
      toast.error("Failed to update case study count");
    }
  };

  // No longer needed: score is always set in updateQnaDetails

  const handleNewAssessmentFormSubmit = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();

    let newAssessmentVar = JSON.parse(
      sessionStorage.getItem("newAssessment") || "false"
    );
    const draftKey = `responses_${proj_id}_${set_name}`;
    const draftResponses = JSON.parse(localStorage.getItem(draftKey) || "[]");

    let submissionAssessmentData = { ...assessmentData };
    if (newAssessmentVar === true && draftResponses.length > 0) {
      // Fetch all questions first to include them in the payload
      try {
        // Use appropriate question API based on flow type
        const questionServiceUrl = fromProjectReadiness
          ? process.env.REACT_APP_READINESS_QUESTION_SERVICE_BASE_URL
          : process.env.REACT_APP_QUESTION_SERVICE_BASE_URL;
        
        const questionEndpoint = fromProjectReadiness
          ? `${questionServiceUrl}/question-readiness`
          : `${questionServiceUrl}/questions`;

        const res = await axiosInstance.get(
          questionEndpoint,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        
        const allQuestions = res.data.filter(
          (item: { set?: any; setName?: any }) => item.set === set_name || item.setName === set_name
        );
        
        // Merge questions with draft responses
        const enhancedResponses = draftResponses.map((response: any) => {
          const matchingQuestion = allQuestions.find((q: any) => q._id === response.questionid);
          return {
            ...response,
            description: matchingQuestion ? matchingQuestion.description : '',
            type: matchingQuestion ? matchingQuestion.type : '',
            values: matchingQuestion ? matchingQuestion.values : [],
            // Include any other question fields you need
          };
        });
        
        submissionAssessmentData = {
          ...assessmentData,
          assessmentdetails: assessmentData.assessmentdetails.map((detail: any) => ({
            ...detail,
            qnadetails: enhancedResponses,
          })),
        };
      } catch (error) {
        console.error("Error fetching questions:", error);
        // Fallback to original behavior if question fetch fails
        submissionAssessmentData = {
          ...assessmentData,
          assessmentdetails: assessmentData.assessmentdetails.map((detail: any) => ({
            ...detail,
            qnadetails: draftResponses,
          })),
        };
      }
    }

    // Only check qnadetails that are not empty objects
    submissionAssessmentData = {
      ...submissionAssessmentData,
      assessmentdetails: submissionAssessmentData.assessmentdetails.map((detail: any) => ({
        ...detail,
        qnadetails: Array.isArray(detail.qnadetails)
          ? detail.qnadetails.filter(
              (qna: any) =>
                qna &&
                typeof qna === "object" &&
                qna.questionid &&
                qna.questionid !== ""
            )
          : [],
      })),
    };

    const hasInvalidQna = submissionAssessmentData.assessmentdetails.some(
      (detail: any) =>
        Array.isArray(detail.qnadetails) &&
        detail.qnadetails.some((qna: any) => {
          if (!qna || typeof qna !== "object") return false;
          if (Object.keys(qna).length === 0) return false;
          return !qna.questionid || qna.questionid === "";
        })
    );

    if (hasInvalidQna) {
      toast.error(
        "Some questions are missing their questionid. Please answer all questions before submitting."
      );
      setIsSubmitButton(true);
      return;
    }

    const isResponseSaved = submissionAssessmentData.assessmentdetails.map(
      (detail: any) => {
        return detail.qnadetails.length > 0;
      }
    );

    if (isResponseSaved.every((saved: any) => saved)) {
      try {
        // ========================================
        // PROJECT READINESS SUBMISSION FLOW
        // Uses readiness APIs and skips LLM processing
        // ========================================
        if (fromProjectReadiness) {
          // Fetch readiness questions and enhance responses
          try {
            const questionServiceUrl = process.env.REACT_APP_READINESS_QUESTION_SERVICE_BASE_URL;
            const res = await axiosInstance.get(
              `${questionServiceUrl}/question-readiness`,
              {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              }
            );
            
            const allQuestions = res.data.filter(
              (item: { set?: any; setName?: any }) => item.set === set_name || item.setName === set_name
            );
            
            // Enhance responses with question data
            const enhanceQnaDetails = (qnadetails: any[]) => {
              return qnadetails.map((qna: any) => {
                const matchingQuestion = allQuestions.find((q: any) => q._id === qna.questionid);
                return {
                  ...qna,
                  description: matchingQuestion ? matchingQuestion.description : qna.description || '',
                  type: matchingQuestion ? matchingQuestion.type : qna.type || '',
                  values: matchingQuestion ? matchingQuestion.values : qna.values || [],
                };
              });
            };
            
            submissionAssessmentData = {
              ...submissionAssessmentData,
              assessmentdetails: submissionAssessmentData.assessmentdetails.map((detail: any) => ({
                ...detail,
                qnadetails: Array.isArray(detail.qnadetails)
                  ? enhanceQnaDetails(detail.qnadetails)
                  : [],
              })),
            };
          } catch (error) {
            console.error("Error fetching readiness questions:", error);
            // Continue with submission even if question fetch fails
          }

          setLoading(true);

          if (!proj_id || !set_name) {
            toast.error(`Missing assessment ID (${proj_id}) or set name (${set_name}). Cannot submit assessment.`);
            setIsSubmitButton(true);
            setLoading(false);
            return;
          }

          // Prepare payload for readiness assessment API
          const readinessPayload = {
            preprojectId: readinessData?.preprojectId || proj_id,
            setName: set_name,
            emailId: submissionAssessmentData.emailIds || [],
            assessmentDetails: submissionAssessmentData.assessmentdetails.map((detail: any) => ({
              ...detail, // Preserve all fields (created_by, modified_by, etc.)
              assessmentdate: detail.assessmentdate || new Date().toISOString(),
              projectstatus: detail.projectstatus || "",
              reasonforchange: detail.reasonforchange || "",
              qnadetails: detail.qnadetails || [],
            })),
            caseStudyCount: 0,
          };

          console.log("Submitting readiness assessment with payload:", readinessPayload);

          // Submit to readiness service
          const readinessServiceUrl = process.env.REACT_APP_READINESS_SERVICE_BASE_URL;
          const assessmentResponse = await axiosInstance.post(
            `${readinessServiceUrl}/createPreprojectAssessment`,
            readinessPayload
          );

          if (!assessmentResponse || !assessmentResponse.data) {
            toast.error("Failed to complete readiness assessment");
            setIsSubmitButton(true);
            setLoading(false);
            return;
          }

          // On successful assessment creation - clear draft data
          localStorage.removeItem(`responses_${proj_id}_${set_name}`);
          localStorage.removeItem(`draft_meta_${proj_id}_${set_name}`);
          
          // Update stored metadata for the assessment
          const assessmentId = assessmentResponse.data.assessmentId || assessmentResponse.data._id;
          if (assessmentId) {
            const existingMetadata = JSON.parse(localStorage.getItem('readinessAssessmentMetadata') || '{}');
            existingMetadata[assessmentId] = {
              ...existingMetadata[assessmentId],
              healthStatus: readinessPayload.assessmentDetails[0]?.projectstatus || "Green",
            };
            localStorage.setItem('readinessAssessmentMetadata', JSON.stringify(existingMetadata));
          }

          toast.success("Project Readiness Assessment submitted successfully!");
          setIsEnabled(false);
          setIsSubmitButton(true);
          setAssessmentJustSubmitted(true);
          setLoading(false);

          // Mark this as no longer a new assessment so scores will be fetched on next view
          sessionStorage.setItem("newAssessment", "false");

          // Navigate back to dashboard with Project Readiness view enabled
          navigate("/dashboard", { state: { showProjectReadiness: true } });
          return;
        }

        // ========================================
        // REGULAR ASSESSMENT SUBMISSION FLOW
        // Uses assessment APIs and triggers LLM processing
        // ========================================
        // If it's an existing assessment (not new), we need to fetch and include question details
        if (newAssessmentVar === false) {
          try {
            // Fetch all questions
            const res = await axiosInstance.get(
              `${process.env.REACT_APP_QUESTION_SERVICE_BASE_URL}/questions`,
              {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              }
            );
            
            const allQuestions = res.data.filter(
              (item: { set?: any; setName?: any }) => item.set === set_name || item.setName === set_name
            );
            
            // For each detail in assessment details, enhance qnadetails with question data
            submissionAssessmentData = {
              ...submissionAssessmentData,
              assessmentdetails: submissionAssessmentData.assessmentdetails.map((detail: any) => ({
                ...detail,
                qnadetails: Array.isArray(detail.qnadetails)
                  ? detail.qnadetails.map((qna: any) => {
                      const matchingQuestion = allQuestions.find((q: any) => q._id === qna.questionid);
                      return {
                        ...qna,
                        description: matchingQuestion ? matchingQuestion.description : '',
                        type: matchingQuestion ? matchingQuestion.type : '',
                        values: matchingQuestion ? matchingQuestion.values : [],
                        // Include any other question fields you need
                      };
                    })
                  : [],
              })),
            };
          } catch (error) {
            console.error("Error fetching questions for existing assessment:", error);
            // Continue with submission even if question fetch fails
          }
        }

        const updatedAssessmentData = {
          ...submissionAssessmentData,
        };
        setLoading(true);

        // Debug: Check if proj_id and set_name are defined
        console.log("API Call Debug - proj_id:", proj_id, "set_name:", set_name);
        console.log("LLM Service Base URL:", process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL);
        console.log("Assessment Service Base URL:", process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL);
        console.log("Full LLM URL will be:", `${process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL}/assessment-llm-summary`);

        // Double-check the environment variable
        const llmBaseUrl = process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL;
        console.log("Raw LLM Base URL:", llmBaseUrl);
        console.log("Type of LLM Base URL:", typeof llmBaseUrl);
        console.log("Is LLM Base URL undefined?", llmBaseUrl === undefined);

        if (!proj_id || !set_name) {
          toast.error(`Missing project ID (${proj_id}) or set name (${set_name}). Cannot submit assessment.`);
          setIsSubmitButton(true);
          setLoading(false);
          return;
        }

        // Step 1: Create/Update assessment
        const assessmentResponse = await axiosInstance.post(
          `${process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL}/create-projectassesment`,
          updatedAssessmentData
        );

        if (!assessmentResponse || !assessmentResponse.data) {
          toast.error("Failed to complete assessment");
          setIsSubmitButton(true);
          setLoading(false);
          return;
        }

        // On successful assessment creation
        localStorage.removeItem(`responses_${proj_id}_${set_name}`);
        localStorage.removeItem(`draft_meta_${proj_id}_${set_name}`);
        toast.success("Assessment Completed successfully");
        setIsEnabled(false);
        setIsSubmitButton(true);
        setAssessmentJustSubmitted(true); // Mark that assessment was created successfully

        // Enable PDF viewing after successful submission and start polling
        // Initially the PDF URL will be blank, so we start polling to check for updates
        setViewPdfEnabled(false); // Keep disabled until actual PDF URL is ready
        setPdfPolling(true); // Start polling for PDF generation

        // Start case study count update process
        updateCaseStudyCountProcess();

        // Step 2: Fetch latest assessment to get assessment_id
        let assessmentId: string | null = null;
        try {
          const assessmentServiceUrl = process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL;
          const latestAssessmentResponse = await axiosInstance.get(
            `${assessmentServiceUrl}/latest-assessment/${proj_id}/${set_name}`
          );

          const latestDetails = latestAssessmentResponse.data?.assessmentdetails;
          if (Array.isArray(latestDetails) && latestDetails.length > 0) {
            assessmentId = latestDetails[0]._id;
          }
          console.log("Latest assessment_id for LLM:", assessmentId);
        } catch (latestErr) {
          console.error("Error fetching latest assessment for LLM:", latestErr);
          toast.error("Unable to fetch latest assessment details. Please try again.");
          // Do not proceed to LLM call if latest-assessment fails
          setLoading(false);
          return;
        }

        // Ensure we have a valid assessmentId before calling LLM
        if (!assessmentId) {
          toast.error("Latest assessment ID not found. Please try again.");
          setLoading(false);
          return;
        }

        // Step 3: Call LLM service with assessment_id in payload
        const llmServiceUrl = process.env.REACT_APP_LLM_SERVICE_BASE_URL;
        console.log("Using LLM Service URL:", llmServiceUrl);

        // Get the authorization token for LLM service
        const authToken = sessionStorage.getItem("PBT_ID_TOKEN");

        console.log("Auth token available:", !!authToken);
        console.log("Auth token first 20 chars:", authToken ? authToken.substring(0, 20) + '...' : 'null');
        console.log("Auth token last 20 chars:", authToken ? '...' + authToken.substring(authToken.length - 20) : 'null');
        // console.log("Making LLM request to:", `${llmServiceUrl}/assessment-llm-summary`);
        console.log("Current window location:", window.location.href);

        // Prepare the LLM payload including assessment_id
        const llmPayload = {
          projectid: updatedAssessmentData.projectid,
          set_name: updatedAssessmentData.set_name,
          emailIds: updatedAssessmentData.emailIds,
          assessmentdetails: updatedAssessmentData.assessmentdetails,
          assessment_id: assessmentId,
          authorization: `Bearer ${authToken}`,
        };

        console.log("LLM Payload:", JSON.stringify(llmPayload, null, 2));

        // Show loader/modal for LLM
        setShowLlmModal(true);

        let llmResponse: any;
        try {
          const response = await axiosInstance.post(
            `${process.env.REACT_APP_LLM_SERVICE_BASE_URL}/assessment-llm-summary`,
            llmPayload,
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
              },
              timeout: 60000 // 60 second timeout for LLM processing
            }
          );
          console.log("LLM Response Status:", response.status);
          console.log("LLM Response Data:", response.data);
          llmResponse = { status: "fulfilled", value: { status: response.status, data: response.data } };
        } catch (error: any) {
          console.error("LLM Proxy Error:", {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            headers: error.response?.headers
          });
          llmResponse = { status: "rejected", reason: error };
        }

        // Handle LLM response
        console.log("LLM Response Debug:", {
          status: llmResponse.status,
          httpStatus: llmResponse.status === "fulfilled" ? llmResponse.value.status : "rejected",
          data: llmResponse.status === "fulfilled" ? llmResponse.value.data : llmResponse.reason
        });

        const wasAssessmentCreated = true;

        // If LLM request was rejected, log detailed error information
        if (llmResponse.status === "rejected") {
          console.error("LLM Request Failed - Detailed Error:", {
            message: llmResponse.reason?.message,
            error: llmResponse.reason
          });
          // If assessment was created but LLM failed, show appropriate message and enable tab
          if (wasAssessmentCreated) {
            toast.warning(
              "Assessment saved successfully! PDF generation failed, but you can still send notifications.",
              {
                autoClose: 5000,
                onClose: () => setShowLlmModal(false)
              }
            );
          } else {
            toast.error("LLM request failed", {
              autoClose: 5000,
              onClose: () => setShowLlmModal(false)
            });
          }
        }
        if (
          llmResponse.status === "fulfilled" &&
          llmResponse.value.status === 202 &&
          llmResponse.value.data?.status === "accepted"
        ) {
          console.log("LLM processing started successfully");
          // LLM started successfully means assessment was also created
          // Keep showLlmModal true - it will be set to false by polling when PDF URL is ready
          setAssessmentJustSubmitted(true);
          // Show toast with navigation instead of modal
          toast.success(
            "Generating a PDF, it will take 1-2 mins.",
            {
              position: "top-center",
              autoClose: 5000,
              closeOnClick: true,
              draggable: false,
              // Don't close showLlmModal here - let polling handle it when PDF is ready
            }
          );
        } else if (llmResponse.status === "fulfilled") {
          console.log("LLM response received but not 202/accepted:", llmResponse.value);
          const errorMsg = llmResponse.value.data?.message || "LLM processing failed";
          // If assessment was created but LLM failed, show appropriate message
          if (wasAssessmentCreated) {
            toast.warning(
              `Assessment saved successfully! ${errorMsg}. You can still send notifications.`,
              {
                autoClose: 5000,
                onClose: () => setShowLlmModal(false)
              }
            );
          } else {
            toast.error(errorMsg, { 
              autoClose: 5000,
              onClose: () => setShowLlmModal(false)
            });
          }
        }
      } catch (error) {
        console.log("Error:", error);
        toast.error("Failed to complete assessment", {
          autoClose: 5000,
          onClose: () => setShowLlmModal(false) // Enable Send Notification tab when error toast is dismissed
        });
        setIsSubmitButton(true);
        // Keep modal state true until toast is dismissed
      } finally {
        setLoading(false);
      }
    } 
    // else if (draftResponses.length === 0) {
    //   toast.error("Please save your responses as a draft before submitting.");
    //   setIsSubmitButton(true);
    // }
    // Removed "unsaved changes" toast - no longer showing this message
    // else {
    //   toast.error("You have some unsaved changes, please save to continue");
    //   setIsSubmitButton(true);
    // }
  };

  const handleOpenClose = () => {
    setIsOpen(!isopen);
  };
  const handleEditSubmit = async () => {
    const { proj_desc, reviewer } = projectData;
    if (!reviewerNames.includes(projectData.reviewer)) {
      toast.error("Please select PBT Assessor from suggestions!");
      return;
    }
    try {
      const res = await axiosInstance.patch(
        `${process.env.REACT_APP_DASHBOARD_SERVICE_BASE_URL}/update/${proj_id}/${set_name}`,
        { proj_desc, reviewer }
      );
      if (isEnabled) {
        toast.success("Project Data is updated successfully");
        setIsEnabled(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleReviewerOnClick = (value: string) => {
    setProjectData((prevData: any) => ({
      ...prevData,
      reviewer: value,
    }));
    console.log(projectData);
  };

  const handleReviewerBlur = () => {
    setTimeout(() => {
      setReviewerData(null);
    }, 150);
  };

  // Handlers for Project Readiness form editable fields
  const handleReadinessFormChange = (field: string, value: string) => {
    setReadinessFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setIsReadinessFormModified(true);
    
    // Fetch user suggestions when assessor name changes
    if (field === "assessorName") {
      fetchUserDataForReviewer(value);
    }
  };

  const handleReadinessReviewerOnClick = (value: string) => {
    handleReadinessFormChange("assessorName", value);
    setReviewerData(null); // Close dropdown after selection
  };

  const handleReadinessSubmit = async () => {
    if (!reviewerNames?.includes(readinessFormData.assessorName)) {
      toast.error("Please select PBT Assessor from suggestions!");
      return;
    }
    
    // Get preprojectId from readinessData
    const preprojectId = readinessData?.preprojectId;
    if (!preprojectId) {
      toast.error("Missing preproject ID");
      return;
    }
    
    try {
      // Prepare update payload
      const updatePayload: any = {};
      if (readinessFormData.assessorName) {
        updatePayload.assessorName = readinessFormData.assessorName;
      }
      if (readinessFormData.projectDescription) {
        updatePayload.projectDescription = readinessFormData.projectDescription;
      }
      
      // PUT to preproject readiness service API
      const res = await axiosInstance.put(
        `${process.env.REACT_APP_PRE_PROJECT_READINESS_SERVICE_BASE_URL}/preproject/${preprojectId}`,
        updatePayload
      );
      
      toast.success("Project Readiness Data updated successfully");
      setIsReadinessFormModified(false);
    } catch (error) {
      console.error(error);
      toast.error("Failed to update project readiness data");
    }
  };

  const handleRemoveEmail = async (index: number) => {
    const emailToRemove = emails[index];
    try {
      const response = await axiosInstance.delete(
        `${process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL}/deleteEmail/${proj_id}/${set_name}`,
        { data: { emailId: emailToRemove } }
      );
      if (response.data.message) {
        toast.success(response.data.message);
        setEmails(emails.filter((_, i) => i !== index));
        localStorage.removeItem("emailData");
      }
    } catch (error) {
      console.error("Error deleting email:", error);
      toast.error("Failed to delete email");
    }
  };

  const formatDateToYMD = (isoDate: string) => {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  };

  // Determine whether an assessment already exists for this project/set
  const assessmentCreated = projectHealthData && projectHealthData.length > 0;

  // Check if the latest backend assessment actually has any answered questions
  const latestBackendDetails =
    assessmentCreated &&
    projectHealthData[0] &&
    Array.isArray(projectHealthData[0].assessmentdetails) &&
    projectHealthData[0].assessmentdetails.length > 0
      ? projectHealthData[0].assessmentdetails[0]
      : null;

  const hasBackendQna =
    !!latestBackendDetails &&
    Array.isArray((latestBackendDetails as any).qnadetails) &&
    (latestBackendDetails as any).qnadetails.length > 0;

  // Only treat as "assessment present for report" when backend has QnA data
  const assessmentReadyForReport = assessmentCreated && hasBackendQna;

  // Disable Send Notification tab when no assessment exists or when LLM is actively processing (not polling)
  // If assessment is created (either existing or just submitted), only disable during showLlmModal (active LLM processing)
  const isSendNotificationDisabled = (!assessmentReadyForReport && !assessmentJustSubmitted) || showLlmModal;

  // Helper flags for Generate Report button state
  const noAssessment = !assessmentReadyForReport;
  const reportPresent = !!pdfUrl || viewPdfEnabled;
  const reportGenerating = pdfPolling || showLlmModal || generateReportLoading;

  // Enable Generate Report only when assessment exists, no report is present, and not currently generating
  const isGenerateReportDisabled = noAssessment || reportPresent || reportGenerating;

  // Tooltip message for Generate Report button based on state
  const getGenerateReportTooltip = () => {
    if (noAssessment) {
      return "Please do some assessment first";
    }
    if (reportPresent) {
      return "Report already present";
    }
    if (reportGenerating) {
      return "Report generation in progress. Please wait.";
    }
    return "Assessment is present but no report is generated. Click here to generate PDF.";
  };

  const handleGenerateReport = async () => {
    if (!proj_id || !set_name) {
      toast.error("Missing project ID or set name. Cannot generate report.");
      return;
    }

    if (!assessmentCreated) {
      toast.error("No assessment found to generate report.");
      return;
    }

    try {
      setGenerateReportLoading(true);
      setShowLlmModal(true);

      const assessmentServiceUrl = process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL;

      const latestAssessmentResponse = await axiosInstance.get(
        `${assessmentServiceUrl}/latest-assessment/${proj_id}/${set_name}`
      );

      const latestAssessmentData = latestAssessmentResponse.data || {};
      const latestDetails = latestAssessmentData.assessmentdetails || [];

      if (!Array.isArray(latestDetails) || latestDetails.length === 0) {
        toast.error("Latest assessment details not found.");
        setShowLlmModal(false);
        return;
      }

      let assessmentId: string | null = null;
      if (Array.isArray(latestDetails) && latestDetails.length > 0) {
        assessmentId = latestDetails[0]._id;
      }

      const authToken = sessionStorage.getItem("PBT_ID_TOKEN");

      const llmPayload = {
        projectid: latestAssessmentData.projectid || proj_id,
        set_name: latestAssessmentData.set_name || set_name,
        emailIds: latestAssessmentData.emailIds || [],
        assessmentdetails: latestDetails,
        assessment_id: assessmentId,
        authorization: `Bearer ${authToken}`,
      };

      let llmResponse: any;
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_LLM_SERVICE_BASE_URL}/assessment-llm-summary`,
          llmPayload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
            timeout: 60000,
          }
        );
        llmResponse = {
          status: "fulfilled",
          value: { status: response.status, data: response.data },
        };
      } catch (error: any) {
        console.error("LLM Generate Report Error:", {
          message: error.message,
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
        });
        llmResponse = { status: "rejected", reason: error };
      }

      const wasAssessmentCreated = true;

      if (llmResponse.status === "rejected") {
        console.error("LLM Request Failed (Generate Report)", llmResponse.reason);
        if (wasAssessmentCreated) {
          toast.warning(
            "Assessment exists but PDF generation failed. You can try again later.",
            {
              autoClose: 5000,
              onClose: () => setShowLlmModal(false),
            }
          );
        } else {
          toast.error("LLM request failed while generating report.", {
            autoClose: 5000,
            onClose: () => setShowLlmModal(false),
          });
        }
        return;
      }

      if (
        llmResponse.status === "fulfilled" &&
        llmResponse.value.status === 202 &&
        llmResponse.value.data?.status === "accepted"
      ) {
        // Start polling for PDF generation; modal will be closed when polling finds a valid URL
        setAssessmentJustSubmitted(true);
        setPdfPolling(true);
        toast.success("Generating report PDF. It will be ready in 1-2 minutes.", {
          position: "top-center",
          autoClose: 4000,
        });
      } else if (llmResponse.status === "fulfilled") {
        const errorMsg =
          llmResponse.value.data?.message || "LLM processing failed while generating report.";
        if (wasAssessmentCreated) {
          toast.warning(
            `Assessment exists but report generation failed: ${errorMsg}`,
            {
              autoClose: 5000,
              onClose: () => setShowLlmModal(false),
            }
          );
        } else {
          toast.error(errorMsg, {
            autoClose: 5000,
            onClose: () => setShowLlmModal(false),
          });
        }
      }
    } catch (err) {
      console.error("Unexpected error while generating report:", err);
      toast.error("Unexpected error while generating report.", {
        autoClose: 5000,
        onClose: () => setShowLlmModal(false),
      });
    } finally {
      setGenerateReportLoading(false);
    }
  };

  // function handleSaveEmails(event: MouseEvent<HTMLButtonElement, MouseEvent>): void {
  //   throw new Error("Function not implemented.");
  // }
  // Modal and loader state for LLM - REMOVED DUPLICATES

  return (
    <>
      {/* <SaveAssessmentDetails
        assessmentData={assessmentData}
        projectId={proj_id || ""}
      /> */}

      <form onSubmit={handleNewAssessmentFormSubmit}>
        <ProjectDetailsBar
          projectid={projectData.proj_id}
          projectName={fromProjectReadiness && readinessData ? readinessData.projectName : projectData.proj_name}
          set_name={fromProjectReadiness && readinessData ? readinessData.assessmentType : projectData.set_name}
          showDetails={showDetails}
          handleProjectDetailsBar={handleOpenClose}
          health={projectHealthData[0]?.assessmentdetails?.[0]?.projectstatus}
          pbtScore={overallScore}
          fromProjectReadiness={fromProjectReadiness}
        />
        {isopen && (
          <Paper
            elevation={3}
            className="behindContentRemover"
            style={{
              padding: "20px",
              maxWidth: "800px",
              width: "100%",
              margin: "auto",
              overflowX: "hidden",
              boxSizing: "border-box",
              translate:'2vh'
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              style={{
                fontWeight: 600,
                color: "#FF5E4F",
                transform: "translateY(-12px)",
              }}
            >
              {fromProjectReadiness ? "Project Readiness Form" : "New Assessment Form"}
            </Typography>
            <Grid container spacing={3}>
              {fromProjectReadiness && readinessData ? (
                // Display Project Readiness Form Data
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Project Name"
                      name="projectName"
                      fullWidth
                      variant="outlined"
                      value={readinessData.projectName || ""}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="DU"
                      name="du"
                      fullWidth
                      variant="outlined"
                      value={readinessData.du || ""}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Account"
                      name="accountName"
                      fullWidth
                      variant="outlined"
                      value={readinessData.accountName || ""}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className="row projectIdInputBoxWithSuggestions"
                  >
                    <TextField
                      label="Assessor (By Name)"
                      name="assessorName"
                      fullWidth
                      variant="outlined"
                      value={readinessFormData.assessorName}
                      onChange={(e) => handleReadinessFormChange("assessorName", e.target.value)}
                      onFocus={(e) => fetchUserDataForReviewer(e.target.value)}
                      onBlur={handleReviewerBlur}
                      style={{ backgroundColor: "#f5f5f5" }}
                      autoComplete="off"
                    />
                    <ul
                      className={reviewer?.length > 0 ? "showProjResults" : ""}
                    >
                      {reviewer?.length > 0 &&
                        reviewer.map((result: any, idx: number) => {
                          return (
                            <li
                              className="resultItems"
                              key={idx}
                              onMouseDown={(e) => {
                                e.preventDefault();
                                handleReadinessReviewerOnClick(result.name);
                              }}
                            >
                              <span> {result.name}</span>
                            </li>
                          );
                        })}
                    </ul>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Assessment Type"
                      name="assessmentType"
                      fullWidth
                      variant="outlined"
                      value={readinessData.assessmentType || ""}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Project Description"
                      name="projectDescription"
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      value={readinessFormData.projectDescription}
                      onChange={(e) => handleReadinessFormChange("projectDescription", e.target.value)}
                      style={{ backgroundColor: "#f5f5f5" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      style={{
                        background: isReadinessFormModified 
                          ? "linear-gradient(135deg, #0d5eff 0%, #073fb1 100%)" 
                          : "grey",
                        color: "white",
                        padding: "10px 24px",
                        borderRadius: "5px",
                      }}
                      onClick={handleReadinessSubmit}
                      disabled={!isReadinessFormModified}
                    >
                      Create and Submit for Assessment
                    </Button>
                  </Grid>
                </>
              ) : (
                // Display Normal Project Form Data
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Project ID (PRJ ID)"
                      name="proj_id"
                      fullWidth
                      variant="outlined"
                      value={projectData.proj_id}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Project Name"
                      name="proj_name"
                      fullWidth
                      variant="outlined"
                      value={projectData.proj_name}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Project Category"
                      name="type"
                      fullWidth
                      variant="outlined"
                      value={projectData.type}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="PM PS ID"
                      name="pmid"
                      fullWidth
                      variant="outlined"
                      value={projectData.pmid}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="PM NAME"
                      name="pmname"
                      fullWidth
                      variant="outlined"
                      value={projectData.pmname}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Account"
                      name="account"
                      fullWidth
                      variant="outlined"
                      value={projectData.account}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Delivery Unit (DU)"
                      name="du"
                      fullWidth
                      variant="outlined"
                      value={projectData.du}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Practice Unit (PU)"
                      name="pu"
                      fullWidth
                      variant="outlined"
                      value={projectData.pu}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Project Start Date (MM-DD-YYYY)"
                      name="proj_start_date"
                      fullWidth
                      variant="outlined"
                      value={convertToIso(projectData.proj_start_date)}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Project End Date (MM-DD-YYYY)"
                      name="proj_end_date"
                      fullWidth
                      variant="outlined"
                      value={convertToIso(projectData.proj_end_date)}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Project Description"
                      name="proj_desc"
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      value={projectData.proj_desc}
                      onChange={handleChange}
                      helperText={
                        isCharLimitExceeded ? (
                          <Typography color="error" variant="body2">
                            Character limit exceeded!
                          </Typography>
                        ) : (
                          <span style={{ color: "grey" }}>{charCount}/100</span>
                        )
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className="row projectIdInputBoxWithSuggestions"
                  >
                    <TextField
                      label="Assessor (By Name)"
                      name="reviewer"
                      fullWidth
                      variant="outlined"
                      value={projectData.reviewer}
                      onChange={handleChange}
                      onFocus={(e) => fetchUserDataForReviewer(e.target.value)}
                      onBlur={handleReviewerBlur}
                      style={{ backgroundColor: "#f5f5f5" }}
                      autoComplete="off"
                    />
                    <ul
                      style={{ translate: "-6px" }}
                      className={reviewer?.length > 0 ? "showProjResults" : ""}
                    >
                      {reviewer?.length > 0 &&
                        reviewer.map((result: any, idx: number) => {
                          return (
                            <li
                              className="resultItems"
                              key={idx}
                              onClick={() => handleReviewerOnClick(result.name)}
                            >
                              <span> {result.name}</span>
                            </li>
                          );
                        })}
                    </ul>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Assessment Type"
                      name="set_name"
                      fullWidth
                      variant="outlined"
                      value={projectData.set_name}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Billing Project ID"
                      name="billing_project_id"
                      fullWidth
                      variant="outlined"
                      value={projectData.billing_project_id}
                      onChange={handleChange}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={projectData.status === "closed"}
                          onChange={handleChange}
                          name="status"
                          color="primary"
                        />
                      }
                      label="Archive"
                    />
                    <Button
                      variant="contained"
                      style={{
                        marginLeft: "16px",
                        background: isEnabled ? "linear-gradient(135deg, #0d5eff 0%, #073fb1 100%)" : "grey",
                        color: "white",
                    padding: "7px",
                    borderRadius: "5px",
                  }}
                  onClick={handleEditSubmit}
                      disabled={!isEnabled}
                    >
                      Create and Submit for Assessment
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        )}

        {}

        {/* section for questions history and findings */}
        <section className="newAssessmentTabSection">
          {/* {progess && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: "#074173",
                translate: "90vh",
              }}
            >
              <RingLoader
                style={{ translate: "12rem -30px" }}
                color="rgb(1, 96, 90)"
                size={20}
              />
              <p style={{ color: "#074173" }}>
                Please hold on as the assessment will be saved shortly&nbsp;{" "}
              </p>
              <ScaleLoader
                color="#074173"
                style={{ translate: "-1px" }}
                height={15}
                width={2}
                margin={2}
              />
            </div>
          )} */}

          {newAssessmentVar === "true" ? (
            <div className="tabsContainer">
              <p
                style={
                  activeTab === "questions"
                    ? {
                        backgroundColor: "#074173",
                        color: "white",
                        borderTopLeftRadius: "10px",
                        position: "relative",
                      }
                    : { color: " #074173", position: "relative" }
                }
                onClick={() => handleTabClick("questions")}
              >
                Questions
                {hasDraft && (
                  <span
                    style={{
                      background: "#ffb300",
                      color: "black",
                      // fontWeight: 600,
                      fontSize: "5px",
                      // borderRadius: "8px",
                      // padding: "2px 8px",
                      // marginLeft: 8,
                      position: "absolute",
                      top: 2,
                      // right: -60,
                      // boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                    }}
                  >
                    Draft
                  </span>
                )}
              </p>
              {/* Only show other tabs if NOT from Project Readiness Dashboard */}
              {!fromProjectReadiness && (
                <>
                  <p
                    style={
                      activeTab === "findings"
                        ? { backgroundColor: "#074173", color: "white" }
                        : { color: " #074173" }
                    }
                    onClick={() => handleTabClick("findings")}
                  >
                    Findings
                  </p>
                  <p
                    style={
                      activeTab === "attachment"
                        ? { backgroundColor: "#074173", color: "white" }
                        : { color: " #074173" }
                    }
                    onClick={() => handleTabClick("attachment")}
                  >
                    File Upload
                  </p>
                  <Tooltip
                    title={
                      isSendNotificationDisabled ? (
                        <Box
                          sx={{
                            p: 1.5,
                            maxWidth: 280,
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "0.875rem",
                              mb: 0.5,
                              color: "#fff",
                            }}
                          >
                            {(!assessmentCreated && !assessmentJustSubmitted) ? "⚠️ Action Required" : "⏳ Please Wait"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.8rem",
                              color: "rgba(255,255,255,0.9)",
                              lineHeight: 1.4,
                            }}
                          >
                            {(!assessmentCreated && !assessmentJustSubmitted)
                              ? "Please submit an assessment first before sending notifications."
                              : "PDF generation is in progress. Please wait for it to complete before sending notifications."}
                          </Typography>
                        </Box>
                      ) : (
                        ""
                      )
                    }
                    arrow
                    placement="bottom"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#1a1a2e",
                          borderRadius: "8px",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
                          border: "1px solid rgba(255,255,255,0.1)",
                          "& .MuiTooltip-arrow": {
                            color: "#1a1a2e",
                          },
                        },
                      },
                    }}
                  >
                    <p
                      style={
                        activeTab === "email"
                          ? { backgroundColor: "#074173", color: "white" }
                          : { color: " #074173" }
                      }
                      onClick={() => {
                        if (!isSendNotificationDisabled) handleTabClick("email");
                      }}
                      className={isSendNotificationDisabled ? "disabledTab" : ""}
                    >
                      Send Notification
                    </p>
                  </Tooltip>
                  <p
                    style={
                      activeTab === "case_study"
                        ? { backgroundColor: "#074173", color: "white" }
                        : { color: " #074173" }
                    }
                    onClick={() => handleTabClick("case_study")}
                  >
                    Case Studies
                  </p>
                </>
              )}
            </div>
          ) : (
            <div className="tabsContainer">
              <p
                style={
                  activeTab === "questions"
                    ? {
                        backgroundColor: "#f5f5f5",
                        color: "black",
                        // borderTopLeftRadius: "5px",
                        // borderTopRightRadius: "5px",
                        height: "30px",
                        borderTop: "3px solid #FF5E4F",
                        translate: "0px 2px",
                        lineHeight: "25px",
                        // right: "5px",
                        position: "relative",
                        fontWeight: "bold",
                      }
                    : {
                        // borderLeft: "1px solid grey",
                        height: "30px",
                        textAlign: "center",
                        color: "grey",
                        backgroundColor: "#ddd",
                        // borderTopLeftRadius: "4px",
                        translate: "0px 2px",
                        lineHeight: "30px",
                        // right: "5px",
                        position: "relative",
                      }
                }
                onClick={() => handleTabClick("questions")}
              >
                Questions
                {hasDraft && (
                  <span
                    style={{
                      background: "#ffb300",
                      color: "black",
                      // fontWeight: 600,
                      fontSize: "5px",
                      // borderRadius: "8px",
                      // padding: "2px 8px",
                      // marginLeft: 8,
                      position: "absolute",
                      top: 2,
                      // right: -60,
                      // boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                    }}
                  >
                    Draft
                  </span>
                )}
              </p>
              {/* Only show other tabs if NOT from Project Readiness Dashboard */}
              {!fromProjectReadiness && (
                <>
                  <p
                    style={
                      activeTab === "history"
                        ? {
                            backgroundColor: "#f5f5f5",
                            // borderTopLeftRadius: "5px",
                            // borderTopRightRadius: "5px",
                            color: "black",
                            height: "30px",
                            borderTop: "3px solid #FF5E4F",
                            fontWeight: "bold",
                            translate: "0px 2px",
                            // marginTop: '10px'
                            lineHeight: "25px",
                          }
                        : {
                            height: "30px",
                            borderLeft: "1.6px solid grey",
                            color: "grey",
                            backgroundColor: "#ddd",
                            // borderTopLeftRadius: "4px",
                            translate: "0px 2px",
                            lineHeight: "30px",
                          }
                    }
                    onClick={() => handleTabClick("history")}
                  >
                    History
                  </p>
                  <p
                    style={
                      activeTab === "findings"
                        ? {
                            backgroundColor: "#f5f5f5",
                            // borderTopLeftRadius: "5px",
                            // borderTopRightRadius: "5px",
                            color: "black",
                            height: "28px",
                            borderTop: "3px solid #FF5E4F",
                            fontWeight: "bold",
                            translate: "0px 1.5px",
                            lineHeight: "25px",
                          }
                        : {
                            height: "30px",
                            borderLeft: "1.6px solid grey",
                            color: "grey",
                            backgroundColor: "#ddd",
                            // borderTopLeftRadius: "4px",
                            translate: "0px 2px",
                            lineHeight: "30px",
                          }
                    }
                    onClick={() => handleTabClick("findings")}
                  >
                    Findings
                  </p>
                  <p
                    style={
                      activeTab === "attachment"
                        ? {
                            backgroundColor: "#f5f5f5",
                            // borderTopLeftRadius: "5px",
                            // borderTopRightRadius: "5px",
                            color: "black",
                            height: "30px",
                            borderTop: "3px solid #FF5E4F",
                            fontWeight: "bold",
                            translate: "0px 2px",
                            lineHeight: "25px",
                          }
                        : {
                            borderLeft: "1.6px solid grey",
                            color: "grey",
                            height: "30px",
                            backgroundColor: "#ddd",
                            // borderTopLeftRadius: "4px",
                            translate: "0px 2px",
                            lineHeight: "30px",
                          }
                    }
                    onClick={() => handleTabClick("attachment")}
                  >
                    File Upload
                  </p>
                  <Tooltip
                    title={
                      isSendNotificationDisabled ? (
                        <Box
                          sx={{
                            p: 1.5,
                            maxWidth: 280,
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "0.875rem",
                              mb: 0.5,
                              color: "#FF5E4F",
                            }}
                          >
                            {(!assessmentCreated && !assessmentJustSubmitted) ? "⚠️ Action Required" : "⏳ Please Wait"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.8rem",
                              color: "#FF5E4F",
                              lineHeight: 1.4,
                            }}
                          >
                            {(!assessmentCreated && !assessmentJustSubmitted)
                              ? "Please submit an assessment first before sending notifications."
                              : "PDF generation is in progress. Please wait for it to complete before sending notifications."}
                          </Typography>
                        </Box>
                      ) : (
                        ""
                      )
                    }
                    arrow
                    placement="bottom"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                          border: "1px solid #e0e0e0",
                          "& .MuiTooltip-arrow": {
                            color: "#ffffff",
                            "&::before": {
                              border: "1px solid #e0e0e0",
                            },
                          },
                        },
                      },
                    }}
                  >
                    <p
                      style={
                        activeTab === "email"
                          ? {
                              backgroundColor: "#f5f5f5",
                              // borderTopLeftRadius: "4px",
                              // borderTopRightRadius: "4px",
                              color: "black",
                              borderTop: "3px solid #FF5E4F",
                              fontWeight: "bold",
                              height: "30px",
                              translate: "0px 2px",
                              lineHeight: "25px",
                            }
                          : {
                              borderLeft: "1.6px solid grey",
                              color: "grey",
                              backgroundColor: "#ddd",
                              // borderTopLeftRadius: "4px",
                              height: "30px",
                              translate: "0px 2px",
                              lineHeight: "30px",
                            }
                      }
                      onClick={() => {
                        if (!isSendNotificationDisabled) handleTabClick("email");
                      }}
                      className={isSendNotificationDisabled ? "disabledTab" : ""}
                    >
                      Send Notification
                    </p>
                  </Tooltip>
                  <p
                    style={
                      activeTab === "case_study"
                        ? {
                            backgroundColor: "#f5f5f5",
                            color: "black",
                            borderTop: "3px solid #FF5E4F",
                            fontWeight: "bold",
                            height: "30px",
                            translate: "0px 2px",
                            lineHeight: "25px",
                          }
                        : {
                            borderLeft: "1.6px solid grey",
                            color: "grey",
                            backgroundColor: "#ddd",
                            height: "30px",
                            translate: "0px 2px",
                            lineHeight: "30px",
                          }
                    }
                    onClick={() => handleTabClick("case_study")}
                  >
                    Case Studies
                  </p>
                </>
              )}
              
              {isAssessForThisProjId && activeTab === "questions" && (
                <div className="reAssessBtn">
                  {" "}
                  {newAssessmentVar === false ? (
                    <input
                      type="button"
                      onClick={() => {
                        setIsReAssessClicked(true);
                        dispatch(updateNewAssessmentVariable(true));
                        sessionStorage.setItem("newAssessment", "true");
                        // Preserve old projectstatus and reasonforchange from existing assessment
                        if (projectHealthData.length > 0) {
                          const oldStatus = projectHealthData[0]?.assessmentdetails?.[0]?.projectstatus || "";
                          const oldReason = projectHealthData[0]?.assessmentdetails?.[0]?.reasonforchange || "";
                          setAssessmentData((prevState: any) => ({
                            ...prevState,
                            assessmentdetails: prevState.assessmentdetails.map((detail: any) => ({
                              ...detail,
                              projectstatus: oldStatus,
                              reasonforchange: oldReason,
                            })),
                          }));
                        }
                      }}
                      value={"Re-Assessment"}
                    />
                  ) : (
                    <input
                      type="button"
                      onClick={() => {
                        setIsReAssessClicked(false);
                        dispatch(updateNewAssessmentVariable(false));
                        sessionStorage.setItem("newAssessment", "false");
                        // For Project Readiness, navigate back to dashboard on cancel if desired
                        // Or simply reset state to show previous assessment
                      }}
                      value={"Cancel"}
                    />
                  )}{" "}
                </div>
              )}{" "}
            </div>
          )}
          <div
            style={{
              transform:
                activeTab === "questions"
                  ? (newAssessmentVar === true || newAssessmentVar === "true")
                    ? "translate(0px, 50px)"
                    : "translate(0px, 50px)"
                  : "none",
            }}
          >
            {newAssessmentVar === "true" ? (
              projectData.set_name !== "" ? (
                (activeTab === "questions" && (
                  <>
                    {" "}
                    {newAssessmentVar === true ? (
                      // ✅ Fetch fresh questions from question DB
                      <Question
                        projectid={proj_id}
                        setname={set_name}
                        onData={updateQnaDetails}
                        onScoreUpdate={handleScoreUpdate}
                        projectstatus={assessmentData.assessmentdetails[0].projectstatus}
                        reasonforchange={assessmentData.assessmentdetails[0].reasonforchange}
                        fromProjectReadiness={fromProjectReadiness}
                      />
                    ) : (
                      // ✅ Show saved questions from assessment backend
                      <div className="savedAssessmentQuestions">
                        {" "}
                        {loading ? (
                          <p>Loading saved questions...</p>
                        ) : (
                          assessmentData.assessmentdetails[0].qnadetails.map(
                            (qna: any, index: number) => (
                              <div key={index} className="questionCard" >
                                <h4>{qna.description}</h4>{" "}
                                <p>
                                  <strong>Type:</strong> {qna.type}
                                </p>{" "}
                                <p>
                                  <strong>Response:</strong> {qna.response}
                                </p>{" "}
                                <p>
                                  <strong>Remarks:</strong> {qna.remarks}
                                </p>{" "}
                              </div>
                            )
                          )
                        )}{" "}
                      </div>
                    )}{" "}
                  </>
                )) ||
                (activeTab === "findings" && (
                  <Findings onFindingsUpdate={setFindings} />
                )) ||
                (activeTab === "case_study" && (
                  <CaseStudy projectid={proj_id} setname={set_name} pu={projectData.pu} />
                ))
              ) : (
                <Loading />
              )
            ) : projectData.set_name !== "" ? (
              (activeTab === "questions" && (
                <Question
                  projectid={proj_id}
                  setname={set_name}
                  onData={updateQnaDetails}
                  onScoreUpdate={handleScoreUpdate}
                  projectstatus={assessmentData.assessmentdetails[0].projectstatus}
                  reasonforchange={assessmentData.assessmentdetails[0].reasonforchange}
                  fromProjectReadiness={fromProjectReadiness}
                />
              )) ||
              (activeTab === "history" && (
                <History projectid={proj_id} set={set_name} color={color}/>
              )) ||
              (activeTab === "findings" && (
                <Findings onFindingsUpdate={setFindings} />
              )) ||
              (activeTab === "attachment" && (
                <FileUpload
                  projectid={proj_id}
                  setName={set_name}
                  emails={emails}
                />
              )) ||
              (activeTab === "email" && (
                <SendNotification projectid={proj_id} setName={set_name} />
              )) ||
              (activeTab === "case_study" && (
                <CaseStudy projectid={proj_id} setname={set_name} pu={projectData.pu} />
              ))
            ) : (
              <Loading />
            )}
          </div>
        </section>

        {activeTab === "questions" && (
          <section className="projectHealthSectionMain">
            <div>
              <div className="projectHealthSection">
                <p>Project Health</p>
                <div className="projectHealthInputContainer">
                  {newAssessmentVar === false &&
                  projectHealthData.length > 0 ? (
                    <div>
                      <label>Project Status</label>
                      <select
                        name="projectstatus"
                        onChange={exsistingFunctionWithColorChange}
                        disabled={projectHealthData.length > 0}
                        value={
                          projectHealthData[0].assessmentdetails[0]
                            .projectstatus
                        }
                      >
                        <option defaultValue="Select Project Status">
                          Select Project Status
                        </option>
                        <option value="red">Red</option>
                        <option value="amber">Amber</option>
                        <option value="green">Green</option>
                      </select>
                    </div>
                  ) : (
                    <div>
                      <label>Project Status</label>
                      <select
                        name="projectstatus"
                        onChange={exsistingFunctionWithColorChange}
                        value={
                          assessmentData.assessmentdetails[0].projectstatus
                        }
                      >
                        <option defaultValue="Select Project Status">
                          Select Project Status
                        </option>
                        <option value="red">Red</option>
                        <option value="amber">Amber</option>
                        <option value="green">Green</option>
                      </select>
                    </div>
                  )}
                  {newAssessmentVar === false &&
                  projectHealthData.length > 0 ? (
                    <div>
                      <label>
                        Reason for change{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="reasonforchange"
                        onChange={exsistingFunctionWithColorChange}
                        readOnly
                        disabled
                        value={
                          projectHealthData[0].assessmentdetails[0]
                            .reasonforchange
                        }
                        style={{ translate: "0px -2px" }}
                      />
                    </div>
                  ) : (
                    <div>
                      <label>
                        Reason for change{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="reasonforchange"
                        onChange={handleAssesmentChange}
                        value={
                          assessmentData.assessmentdetails[0].reasonforchange
                        }
                        style={{ translate: "0px -2px" }}
                      />
                    </div>
                  )}
                  {newAssessmentVar === false &&
                  projectHealthData.length > 0 ? (
                    <div>
                      <label>Date (MM-DD-YYYY)</label>
                      <input
                        name="assessmentdate"
                        readOnly
                        disabled
                        value={formattedDate}
                        onChange={handleAssesmentChange}
                      />
                    </div>
                  ) : (
                    <div>
                      <label>Date (MM-DD-YYYY)</label>
                      <input
                        name="assessmentdate"
                        readOnly
                        disabled
                        value={formattedDate}
                        onChange={handleAssesmentChange}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="newAssessmentFormBtn" style={fromProjectReadiness ? { display: 'flex', justifyContent: 'center', alignItems: 'center' } : undefined}>
              {/* <div style={{ display: "inline-block", position: "relative" }}>
                <input
                  type="checkbox"
                  checked={isChecked}
                  style={{ translate: "-80px -13px" }}
                  onChange={handleCheckboxChange}
                />
                <input
                  type="button"
                  onClick={handleButtonClick}
                  disabled={!isChecked}
                  value="Email Alert"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1rem",
                    padding: "12px 30px",
                    cursor: isChecked ? "pointer" : "not-allowed",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    // backgroundColor: isChecked ? "#074173" : "rgba(7, 65, 115, 0.61)",
                    backgroundColor: isChecked ? "#074173" : "#ddd",
                    position: "relative",
                    zIndex: 1,
                    translate: "0px -48px",
                    // height:'100px',
                    color: "white",
                    paddingLeft: "20px",
                  }}
                />
                <MdEmail
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "17px",
                    zIndex: 2,
                    pointerEvents: "none",
                    translate: "2px -39px",
                    color: "white",
                  }}
                />
              </div> */}

              {/* <button
                // disabled={!newAssessmentVar || isSubmitButton || !isEnabled1}
                type="submit"
                style={{
                  whiteSpace: "nowrap",
                  width: "13rem",
                  backgroundColor:'#0d5eff',
                  //   newAssessmentVar && !isSubmitButton && isEnabled1
                  //     ? "#0d5eff"
                  //     : "#ccc",
                  // cursor:
                  //   newAssessmentVar && !isSubmitButton
                  //     ? "pointer"
                  //     : "not-allowed",
                }}
              >
                Save and Submit Assessment
              </button> */}
              {/* Only show Generate Report and View Report if NOT from Project Readiness Dashboard */}
              {!fromProjectReadiness && (
                <>
                  {/* Generate Report - left */}
                  <Tooltip title={getGenerateReportTooltip()} arrow>
                    <span style={{ flex: isMobile ? 1 : '0 0 20%', marginRight: isMobile ? 0 : '0.75rem' }}>
                      <Button
                        type="button"
                        variant="contained"
                        fullWidth={isMobile}
                        disabled={isGenerateReportDisabled}
                        onClick={handleGenerateReport}
                        sx={{
                            background: isGenerateReportDisabled ? "linear-gradient(135deg, #cccccc 0%, #bfbfbf 100%)" : "linear-gradient(135deg, #FF5E4F 0%, #E54536 100%)",
                            paddingY: "1.3rem",
                            paddingX: "2.2rem",
                            fontSize: isMobile ? "1rem" : "1.1rem",
                            borderRadius: "10px",
                            textTransform: "none",
                            whiteSpace: "nowrap",
                            width: "100%",
                            minWidth: 0,
                            maxWidth: isMobile ? "100%" : "100%",
                            lineHeight: 1.6,
                            textAlign: "center",
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                            marginRight: isMobile ? 0 : "0.5rem",
                            marginBottom: isMobile ? "1rem" : 0,
                            flex: isMobile ? 1 : '0 0 auto',
                            "&:hover": {
                              background: isGenerateReportDisabled ? "linear-gradient(135deg, #cccccc 0%, #bfbfbf 100%)" : "linear-gradient(135deg, #E04C44 0%, #C93A2E 100%)",
                            },
                          }}
                      >
                        {generateReportLoading ? "Generating Report..." : "Generate Report"}
                      </Button>
                    </span>
                  </Tooltip>

                  {/* View Report - middle */}
                  <Button
                    variant="outlined"
                    fullWidth={isMobile}
                    disabled={!viewPdfEnabled}
                    onClick={handleViewPdf}
                    sx={{
                      borderColor: viewPdfEnabled ? "#1a73e8" : "#ccc",
                      color: "white !important",
                      paddingY: "1.3rem",
                      paddingX: "2.2rem",
                      fontSize: isMobile ? "1rem" : "1.1rem",
                      borderRadius: "10px",
                      textTransform: "none",
                      whiteSpace: "nowrap",
                      width: "100%",
                      minWidth: 0,
                      maxWidth: "100%",
                      lineHeight: 1.6,
                      textAlign: "center",
                      marginX: isMobile ? 0 : "0.5rem",
                      marginBottom: isMobile ? "1rem" : 0,
                      background: viewPdfEnabled ? "linear-gradient(135deg, #0d5eff 0%, #073fb1 100%)" : "linear-gradient(135deg, #cccccc 0%, #bfbfbf 100%)",
                      flex: 1,
                      "&:hover": {
                        borderColor: viewPdfEnabled ? "#0d5eff" : "#ccc",
                        background: viewPdfEnabled ? "linear-gradient(135deg, #0d5eff 0%, #073fb1 100%)" : "transparent",
                        color: "white !important",
                      },
                      "&.Mui-disabled": {
                        color: "white !important",
                      },
                    }}
                  >
                    {pdfLoading ? "Loading..." : pdfPolling ? "PDF Generating..." : "View Report"}
                  </Button>
                </>
              )}

              {/* Submit Assessment - always visible */}
              <Button
                type="submit"
                variant="contained"
                fullWidth={isMobile}
                sx={{
                  background: "linear-gradient(135deg, #0d5eff 0%, #073fb1 100%)",
                  paddingY: "1.3rem",
                  paddingX: "2.2rem",
                  fontSize: isMobile ? "1rem" : "1.1rem",
                  borderRadius: "10px",
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  width: fromProjectReadiness ? "auto" : "100%",
                  minWidth: fromProjectReadiness ? "300px" : 0,
                  maxWidth: fromProjectReadiness ? "400px" : "100%",
                  lineHeight: 1.6,
                  textAlign: "center",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  flex: fromProjectReadiness ? 'none' : 1,
                  marginLeft: isMobile || fromProjectReadiness ? 0 : "0.5rem",
                  "&:hover": {
                    background: "linear-gradient(135deg, #0d5eff 0%, #073fb1 100%)",
                  },
                }}
              >
                Submit Assessment
              </Button>
            </div>
          </section>
        )}
      </form>
    </>
  );
};

export default NewAssessmentForm;